import scoreBoard from '../../../../../assets/image//validation-score/scoreBoard.svg';
import circleIndicator from '../../../../../assets/image/validation-score/circleIndicator.svg';

interface ValidationScoreBoardProps {
  score: number;
}

// Score thresholds and corresponding rotation degrees (0° → very weak, 180° → very good)
const SCORE_RANGES = [
  {max: 460, degree: 0},
  {max: 520, degree: 45},
  {max: 580, degree: 90},
  {max: 640, degree: 135},
  {max: Infinity, degree: 180},
] as const;

export const getScoreDegree = (score: number): number => {
  const range = SCORE_RANGES.find(range => score < range.max);
  return range ? range.degree : 180;
};

const ValidationScoreBoard = ({score}: ValidationScoreBoardProps) => {
  // Optional: clamp score to a reasonable range (common credit scores: ~300–850)
  const clampedScore = Math.max(300, Math.min(850, score));
  const rotationDegree = getScoreDegree(clampedScore);

  return (
    <div className="relative flex items-center justify-center w-52 h-52">
      {/* Background scoreboard */}
      <img
        src={scoreBoard}
        alt="Credit score gauge background"
        className="object-contain w-full h-full"
      />

      {/* Rotating indicator needle */}
      <img
        src={circleIndicator}
        alt=""
        aria-hidden="true"
        className="absolute object-contain w-20 h-20 transition-transform duration-700 ease-out"
        style={{
          transform: `rotate(${rotationDegree}deg)`,
          transformOrigin: 'center',
        }}
      />

      {/* Numeric score only */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <span
          className="font-bold text-gray-800"
          aria-label={`Credit score: ${clampedScore}`}
        >
          {clampedScore}
        </span>
      </div>
    </div>
  );
};

export default ValidationScoreBoard;
